import { Component } from '@angular/core';
import { HeaderComponent } from "../../shared/components/header/header.component";
import { FooterComponent } from "../../shared/components/footer/footer.component";
import { RouterOutlet } from '@angular/router';
import { Maintenance } from '../../model/maintenance';
import { MaintenanceService } from '../../services/maintenance.service';
import { catchError } from 'rxjs';
import { throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { CommonModule } from '@angular/common';
import { bool } from 'aws-sdk/clients/signer';
import { ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'app-authorizeview',
    standalone: true,
    templateUrl: './authorizeview.component.html',
    styleUrls: ['./authorizeview.component.css'],
    imports: [HeaderComponent, FooterComponent,RouterOutlet, CommonModule]
})
export class AuthorizeViewComponent {
  public isMaintenanceMode: boolean = false;
  public isMaintenancMessage1Dismissed: boolean = false;
  public maintenanceMessage1: string = '';
  public maintenanceMessage2: string = '';
  public maintenanceMessage3: string = '';
  public maintenanceModeDate: string = '';
  public maintenanceModeEndDate: string = '';


  public cachedMaintenanceData?: Maintenance;
  public MMO_refresh: number=3600;
  public refreshInterval: any;

  public readyToRender: boolean =false;
  public maintenancePrior: boolean = false;
  public maintenanceToday: boolean = false;
  public maintenanceTodayIT: boolean = false;
  public maintenanceTodayNonIT: boolean = false;

  constructor(
    private maintenanceService: MaintenanceService,
    public router: Router,
    public auth: AuthService,
    public changedetect: ChangeDetectorRef
  ) {

  }
   private MyErrorHandler(error: any) {
    console.error('Maintenance data fetch failed:', error);
    return throwError(() => error);
  }  

   public maintenanceData(){
     console.log("Maintenance Mode check...");
     this.maintenanceService.getMaintenanceData()
     .pipe(catchError(err=>this.MyErrorHandler(err)))
     .subscribe((result) => {
      this.cachedMaintenanceData=result;
      this.MMO_refresh=this.cachedMaintenanceData.MaintenanceMode_RefreshPeriod;
      console.log(this.cachedMaintenanceData)
      this.applyMaintenanceLogic();
      if (this.refreshInterval) {
        console.log("Celaring existing Refresh intervals")
        clearInterval(this.refreshInterval)
      }
      this.refreshInterval = setInterval(() => {
        console.log("Set a new interval", this.MMO_refresh)
        this.maintenanceData();
        this.changedetect.detectChanges();
      }, this.MMO_refresh * 1000);



     })
  }



ngOnDestroy() {
  console.log("Destroying....")
  if (this.refreshInterval) {
    clearInterval(this.refreshInterval);
  }
}


  get CurrentTimeforMaintennace(){
    this.applyMaintenanceLogic()
    return "";

  }
  public Maintenance1Dismisal()
  {
    sessionStorage.setItem('maintenance1Dismissed', 'true');
    this.isMaintenancMessage1Dismissed = true;
  }



  public applyMaintenanceLogic(){
    const dateToday = new Date();
    const todayDateOnly = new Date(dateToday.getFullYear(), dateToday.getMonth(), dateToday.getDate());
    if (this.cachedMaintenanceData)
      {
      this.maintenanceMessage1 = this.cachedMaintenanceData.MessagePrior;
      this.maintenanceMessage2 = this.cachedMaintenanceData.MessageCurrent;
      this.maintenanceMessage3 = this.cachedMaintenanceData.MessageCurrentIT;
    
      if (this.cachedMaintenanceData.IsMaintenanceMode=='1')
      {
        this.isMaintenanceMode = true;
      }
      else 
      {
        this.isMaintenanceMode = false;
      }
      this.maintenanceModeDate = this.cachedMaintenanceData.MaintenanceDate;
      this.maintenanceModeEndDate = this.cachedMaintenanceData.MaintenanceEndDate;
    }
    const deploymentEndDate = new Date(this.maintenanceModeEndDate);
    const formattedEndTime = deploymentEndDate.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true });

    const deploymentDate = new Date(this.maintenanceModeDate); 
    const deploymentDateOnly = new Date(deploymentDate.getFullYear(), deploymentDate.getMonth(), deploymentDate.getDate());

    this.maintenancePrior = false;
    this.maintenanceToday = false;
    this.maintenanceTodayIT = false;
    this.maintenanceTodayNonIT = false;
    
    if (todayDateOnly < deploymentDateOnly && this.isMaintenanceMode){
      this.maintenancePrior = true;    
    }
    else if (dateToday>=deploymentDate && this.isMaintenanceMode){

      if (!this.cachedMaintenanceData?.ITUsers.includes(this.auth.currentUser.User_Name)){
        this.maintenanceTodayNonIT=true
        const formattedDate = deploymentDate.toLocaleDateString('en-US', {
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric'
                            });
        const formattedTime = deploymentDate.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
        this.maintenanceService.setMaintenanceDate(formattedDate.toString());
        this.maintenanceService.setMaintenanceTime(formattedTime.toString());
        this.maintenanceService.setMaintenanceEndTime(formattedEndTime.toString());

        setTimeout(() => {
          console.log("Rerouting...")
          sessionStorage.setItem('fromRedirect', 'true');
          this.router.navigate(['/maintenance']);
        }, 0);
      }
      else{
        this.maintenanceTodayIT = true;
      }      
    }
    else if (this.isMaintenanceMode){
      this.maintenanceToday = true;
    }
    this.readyToRender = true;
  }

  ngOnInit(): void {

    this.maintenanceData();

    const Maintenance1Dismissed = sessionStorage.getItem('maintenance1Dismissed');
    this.isMaintenancMessage1Dismissed = !!Maintenance1Dismissed

  }
}
